var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKeep24Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 6L9 7V8H6.5V11L6 11.5L5.5 11V8H3V7L4 6V2.5H3.5V1.5H8.5V2.5H8V6ZM4.425 7H7.575L7 6.425V2.5H5V6.425L4.425 7Z",
    fill: "#878889"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeep24Px);
export default __webpack_public_path__ + "static/media/keep_24px.010d425a414f622ec8cb575c815f5551.svg";
export { ForwardRef as ReactComponent };